<template>
    <div>
        <div v-if="showPastNotes">
            <table class="table table-striped table-sm full-width" v-if="notes && notes.length">
                <tr v-for="note in notes" :key="note.id">
                    <td>
                        <small>{{note.userName }} - <a class="noteDate" href="#" onclick="return false;" data-toggle="tooltip" :title="Bandwango.dateToLocal(note.created_at, false, 'MMMM Do YYYY, h:mm:ss a')">{{ Bandwango.dateToLocal(note.created_at)}}</a></small><br/>
                        <span class="font-size-sm" v-html="note.message"></span>
                    </td>
                </tr>
                <tr v-if="notes.length == (page*display)">
                    <td>
                        <div class="text-center text-muted w-100">
                            <div class="btn btn-sm w-100" :class="notes.length % 2 == 1 ? 'border': ''" v-if="!notesLoading" @click="page++; getNotes()">Load More</div>
                            <div v-else class="w-100"><span class="sr-only">Loading...</span></div>
                        </div>
                    </td>
                </tr>
            </table>
            <div v-else>
                No Notes
            </div>
        </div>

        <textarea id="note" class="form-control" v-model="note"></textarea>
        <button :class="'btn btn-sm '+buttonClass" @click.prevent="saveNote()" v-html="buttonText" :disabled="buttonDisabled"></button>
    </div>
</template>

<script>
    export default {
        props: {
			assignment: {
				type: String|Number,
				required: true
			},
			assignmentId: {
				type: String|Number,
				required: true
			},
            showPastNotes:{
			    type: Boolean,
                default: true
            },
            buttonClass: {
			    type: String,
                default: 'btn-outline-primary mt-1 mb-3'
            },
            buttonText: {
			    type: String,
                default:'<i class="fa fa-fw fa-plus mr-1"></i> Add Note'
            },
			buttonDisabled: {
				type: Boolean,
				default: false	
			}
        },
        data:() => {
			return {
                note:'',
                notes: [],
				page: 1,
				display: 5,
                notesLoading:false,
			}
		},

        methods: {
            getNotes() {
                if( !this.assignmentId ) return;
                // TODO:: query pages as user scrolls down the page
                const self = this;
                this.notesLoading = true;
                axios.get('/logs', {
                    params: {
                        level:'note',
                        assignment: this.assignment,
                        assignment_id: this.assignmentId,
                        page: this.page,
                        display: this.display,
                    }
                }).then(response => {
                    self.notes = self.notes.concat(response.data.data);
                    this.notesLoading = false;
                }).catch(e => {
                    this.notesLoading = false;
                });
			},
            saveNote: function() {
                if( !this.note ) return;
				const message = this.note;
				axios.post(`/logs`, {
                    level:'note',
                    assignment: this.assignment,
                    assignment_id: this.assignmentId,
                    message: message
                }).then(response => {
                    this.success_msg = 'Note updated successfully.';
                    this.note = '';
                    this.notes.splice(0, 0, response.data);
                    this.$emit('note-created', response.data);
                }).catch(error => {
                    this.error_msg = error.response.data.message;
                });

            },
        },
        mounted() {
			this.getNotes();
        },
    }
</script>

<style>
    /* why is it not inheriting from the template */
    .pull-right {
        float:right !important;
    }
</style>